import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import CarouselHeader from "../components/common/CarouselHeader";
import FindImmobilieForm from "../components/FindImmobilieForm/FindImmobilieForm";
import OurServices from "../components/OurServices/OurServices";
import Regions from "../components/Regions/Regions";
import LastMinutes, {OfferInterface} from "../components/common/LastMinutes";
import {ReactElement, useEffect, useState} from "react";
import Layout from "../components/common/Layout";
import {dehydrate, DehydratedState, QueryClient, useQuery} from "@tanstack/react-query";
import {GetServerSideProps} from "next";
import {getLastMinuteItems} from "./api/last-minutes";
import {Filter} from "../data/Filter/Filter.config";
import {fetchItem} from "../data/ReactQueries";
import {ObjectInterfaceWithCity} from "../interfaces/ObjectInterface";
import {ParsedUrlQuery} from "querystring";
import {useRouter} from "next/router";
import {useMediaQuery} from "../hooks/useMediaQuery";
import {getSafeLocale} from "../helpers/LocalizeObject";
import ImmobilieKaufenHome, {ImmobilieKaufenHomePropsInterface} from "../components/common/ImmobilieKaufenHome";
import HomeMarinaAmMittelmeer from "../components/common/HomeMarinaAmMittelmeer";
import HomeKaufenUndVerkaufen from "../components/common/HomeKaufenUndVerkaufen";
import HomeBanner from "../components/common/HomeBanner";

interface HomeInterface {
	initialQuery: ParsedUrlQuery;
	objects: ObjectInterfaceWithCity[];
	dehydratedState: DehydratedState;
}

export default function Home(props: HomeInterface) {
	const router = useRouter();
	console.log(router.locale);
	const {
		data: objects,
		isLoading: objectsLoading,
		refetch
	} = useQuery(
		["lastMinutes", {[Filter.Rent.queryKey]: 1, locale: router.locale}],
		(): Promise<OfferInterface[]> => {
			return fetchItem(
				"last-minutes",
				{
					[Filter.Rent.queryKey]: 1
				},
				router.locale
			);
		}
	);

	const {
		data: SaleObjects,
	} = useQuery(
		[
			"SaleObjects",
			{[Filter.Sale.queryKey]: 1, locale: router.locale}
		],
		() => {
			return fetchItem(
				"objects",
				{
					[Filter.Sale.queryKey]: 1
				},
				router.locale
			);
		}
	);

	const [upperComponentHeight, setUpperComponentHeight] = useState(0);

	const scrollToHashTarget = () => {
		if (router.asPath.includes("#")) {
		const id = router.asPath.split("#")[1];
		const el = document.getElementById(id);
		if (el) {
			setTimeout(() => {
				el.scrollIntoView({ behavior: "smooth", block: "end" });
			}, 100);
		}
		}
	};

	useEffect(() => {
		scrollToHashTarget();
	}, [router.asPath]);

	useEffect(() => {
		const handleHashChange = () => {
			scrollToHashTarget();
		};

		window.addEventListener("hashchange", handleHashChange);
		return () => window.removeEventListener("hashchange", handleHashChange);
	}, []);

	useEffect(() => {
		const upperComponent = document.getElementById("upperComponent");

		if (upperComponent) {
			const upperComponentHeight = upperComponent.offsetHeight;
			setUpperComponentHeight(upperComponentHeight);
			// nextComponent.style.marginTop = `${upperComponentHeight}px`;
		}
	}, []);

	const {currentScreenAsNumber} = useMediaQuery();

	return (
		<>
			<CarouselHeader/>

			<div className=" bg-white container mx-auto font-lato">
				<FindImmobilieForm/>
				{/* {currentScreenAsNumber > ScreenNumber.md ? (
          <div style={{ paddingTop: upperComponentHeight / 1.45 }} />
        ) : (
          <div className="pt-36" />
        )} */}
				<div className="pt-10 lg:pt-36"/>
				<div className="sm:w-[95%] xl:w-10/12 ml-4 sm:mx-auto max-w-[1480px]">
					<LastMinutes objects={objects ?? []}/>
				</div>
				<div className="pt-10 lg:pt-20"/>
				<div className="w-[95%] xl:w-10/12 mx-auto max-w-[1480px]">
					<HomeBanner />
				</div>
				<div className="pt-10 lg:pt-20"/>
				<div className="sm:w-[95%] xl:w-10/12 ml-4 sm:mx-auto">
					<ImmobilieKaufenHome objects={SaleObjects?.items ?? []}/>
				</div>
				{/* <div className="pt-36"/>
				<div className="">
					<OurServices/>
					<div className="pt-16"/>
					<Regions/>
					<div className="pt-16"/>
				</div> */}
			</div>

			<div className="pt-10 lg:pt-20"/>

			<HomeMarinaAmMittelmeer />

			<HomeKaufenUndVerkaufen />
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const queryClient = new QueryClient();
	const objects = await getLastMinuteItems();
	queryClient.setQueryData(
		["lastMinutes", {[Filter.Rent.queryKey]: 1, locale: getSafeLocale(context.locale)}],
		objects
	);
	console.log("context locale", context.locale);
	console.log("header locale", context.req.headers["accept-language"]);
	const translations = (await serverSideTranslations(getSafeLocale(context.locale) as string, ["common"]));
	return {
		props: {
			dehydratedState: dehydrate(queryClient),
			objects: objects,
			initialQuery: context.query,
			...translations
		}
	};
};

// export async function getStaticProps({ locale }: any) {
//   return {
//     props: {
//       ...(await serverSideTranslations(locale, ["common"])),
//     },
//   };
// }

Home.getLayout = function getLayout(page: ReactElement) {
	return <Layout>{page}</Layout>;
};
